import React, { useState, useEffect } from 'react';
import { FLAVOR, icons } from "../helpers/constants";
import { useTranslation } from "react-i18next";
import Account from '../components/Settings/Account';
import Safety from '../components/Settings/Safety';
import Devices from '../components/Settings/Devices';
import Billing from '../components/Settings/Billing';
import Notifications from '../components/Settings/Notifications';
import Support from '../components/Settings/Support';
import Warranty from '../components/Settings/Warranty';
import Manuals from '../components/Settings/Manuals';
import ApiAccess from '../components/Settings/ApiAccess';
import LogoutModal from '../components/Modals/LogoutModal';
import { useIsMobile } from '../helpers/customHooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSidebarContext } from '../components/Sidebar/SiderbarContext';
import { motion } from "framer-motion";

const SettingsNew = ({}) => {
	const MOBILE = useIsMobile();
	const navigate = useNavigate();
	const [selected, setSelected] = useState(null)
	const { t } = useTranslation();
	const [showLogout, setShowLogout] = useState(false)
	const [isOpen, setIsOpen] = useState(false)
	const [ticketOpen, setTicketOpen] = useState(false)
	const [ticketId, setTicketId] = useState(null)
	const location = useLocation();
	const [outerType, setOuterType] = useState(null)
	const [selectedDevice, setSelectedDevice] = useState(null)
	const { topbarContent, setTopbarContent, topbarTwoContent, setTopbarTwoContent } = useSidebarContext();

	useEffect(() => {
		
		return() => {
			setTopbarTwoContent(null);
		}
	}, [])

	useEffect(() => {
		const ticketid = location?.state?.ticketid ?? null;

		if (!ticketid) return;

		setSelected("support");
		setTicketId(ticketid);

		// ✅ Clear state by replacing current history entry
		navigate(location.pathname, { replace: true });
	}, [location.state, location.pathname, navigate]);

	const renderSettingsType = (type) => {
		switch (type){
			case "account": return <Account isOpen={isOpen} setIsOpen={setIsOpen} outerType={outerType} setOuterType={setOuterType}/>
			case "safety": return <Safety />
			case "devices": return <Devices isOpen={isOpen} setSelectedDevice={setSelectedDevice} setIsOpen={setIsOpen} outerType={outerType} setOuterType={setOuterType}/>
			case "billing": return <Billing />
			case "notifications": return <Notifications />
			case "support": return <Support isOpen={isOpen} setIsOpen={setIsOpen} outerType={outerType} setOuterType={setOuterType} setTicketId={setTicketId} ticketId={ticketId} /* ticketOpen={ticketOpen} setTicketOpen={setTicketOpen} */ />
			case "warranty": return <Warranty />
			case "manuals": return <Manuals />
			case "api": return <ApiAccess />
			default: return null
		}
	}

	const backClick = () => {
		if(outerType){
			setOuterType(null)
			return
		}
		if(isOpen){
			setIsOpen(false)
			return
		}
		if(!isOpen){
			setSelected(null)
			return
		}
		if(ticketOpen){
			setTicketOpen(false)
			return
		}

	}


	const firstBatch = ["account", /*"safety", "logout"*/]
	const secondBatch = ["bike", "alco"].includes(FLAVOR) ? ["devices"] : ["devices", /*"billing",*/ "api"]
	const thirdBatch = ["notifications"]
	const fourthBatch = ["support"]
	const fifthBatch = ["logout"]




	useEffect(() => {
		setSelectedDevice(null);
		setOuterType(null);
	}, [selected])


	useEffect(() => {
		if(!selected){
			setTopbarContent(null)
			setTopbarTwoContent(null)
			return;
		}
		if(MOBILE){
			const topcontent = {
				left: (
					<div className="cursor-pointer round-bg bg-white menu-button d-flex align-items-center justify-content-center" onClick={backClick}>
						<motion.img key="close" src={icons.chevron_left} alt="close" className="size_15 primary-icon" initial={{ opacity: 1, rotate: 90 }} animate={{ opacity: 1, rotate: 0 }} exit={{ opacity: 1, rotate: 180 }} transition={{ duration: 0.2 }} />
					</div>	
				),
				center: (
					<motion.h4 key="title" className="position-absolute top-50 start-50 translate-middle m-0 text-truncate w-50 text-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}>
						{`${outerType ? t(`settings.${outerType}`) : selectedDevice ? selectedDevice : t(`settings.${selected}`)}`}
					</motion.h4>
				)
			}
			setTopbarContent({...topbarContent, ...topcontent})
		}else{
			const topcontent = {
				center: (
					<motion.h4 key="title" className="position-absolute top-50 start-50 translate-middle m-0 text-truncate w-50 text-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}>
						{t(`settings.settings`)}
					</motion.h4>
				)
			}
			const topTwoContent = {
				left: (
					<div className="d-flex align-items-center">
						<div className="cursor-pointer round-bg bg-white menu-button d-flex align-items-center justify-content-center" onClick={backClick}>
							<motion.img key="close" src={icons.chevron_left} alt="close" className="size_15 primary-icon" initial={{ opacity: 1, rotate: 90 }} animate={{ opacity: 1, rotate: 0 }} exit={{ opacity: 1, rotate: 180 }} transition={{ duration: 0.2 }} />
						</div>	
						<motion.h4 key="title" className="ms-3" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}>
								<span>{`${t(`settings.${selected}`)} `}</span>
								{selectedDevice && (
									<span className="truncate-device">
										{`/ ${selectedDevice}`}
									</span>
								)}

								{outerType && (
									<span>
										{` / ${t(`settings.${outerType}`)}`}
									</span>
								)}
						</motion.h4>
					</div>
					),
				right: null,
				action: null
			}

			setTopbarContent({...topbarContent, ...topcontent});
			setTopbarTwoContent({...topbarTwoContent, ...topTwoContent})
		}


	}, [selected, isOpen, outerType, selectedDevice])

	const settingsListContent = () => {
		if(MOBILE && selected) return;
		return(
		<>
		<div className={`info-section-nomap section-divider position-relative scrollable-y grey-blue padding-bottom-20`}>
			<div className="margin-x-20">
			<p className={`mb-1 bold mt-3`}>{t("settings.my_account")}</p>
				<div className="d-flex flex-column settings-radius">
					{firstBatch.map((item, index) =>(
						<div 
							key={index} 
							onClick={() => item !== "logout" ? setSelected(item) : setShowLogout(true)}
							className={`p-3 d-flex justify-content-between align-items-center cursor-pointer ${index < firstBatch.length-1 ? "border-settings" : ""} ${selected === item ? "bg-grey-blue white" : "bg-white grey-blue"}`}>
							{
								item === "account"
								? <span className=" body">{t("settings.edit_account")}</span>
								: item === "safety"
								? <span className="body">{t("settings.safety")}</span>
								: <span className="body red">{t("settings.logout")}</span>
							}
							<img className={`size_15 ${selected === item ? "white-icon": "primary-icon"}`} src={icons.chevron_right} alt={""} />
						</div>
					))}
				</div>

				<p className="mt-3 mb-1 bold">{t("settings.management")}</p>
				<div className="d-flex flex-column settings-radius primary">
					{secondBatch.map((item, index) =>(
						<div 
							key={index} 
							onClick={() => setSelected(item)}
							className={`p-3 d-flex justify-content-between align-items-center cursor-pointer ${index < secondBatch.length-1 ? "border-settings" : ""} ${selected === item ? "bg-grey-blue white" : "bg-white grey-blue"}`}>
							{
								<span className={`body`}>{t(`settings.${item}`)}</span>

							}
							<img className={`size_15 ${selected === item ? "white-icon": "primary-icon"}`} src={icons.chevron_right} alt={""} />
						</div>
					))}
				</div>
				<p className="mt-3 mb-1 bold">{t("settings.notifications")}</p>
				<div className="d-flex flex-column settings-radius primary">
					{thirdBatch.map((item, index) =>(
						<div 
							key={index} 
							onClick={() => setSelected(item)}
							className={`p-3 d-flex justify-content-between align-items-center cursor-pointer ${""} ${selected === item ? "bg-grey-blue white" : "bg-white grey-blue"}`}>
							<span className="body">{t("settings.notifications")}</span>
							<img className={`size_15 ${selected === item ? "white-icon": "primary-icon"}`} src={icons.chevron_right} alt={""} />
						</div>
					))}
				</div>
				<p className="mt-3 mb-1 bold">{t("settings.support")}</p>
				<div className="d-flex flex-column settings-radius primary">
					{fourthBatch.map((item, index) =>(
						<div 
							key={index} 
							onClick={() => setSelected(item)}
							className={`p-3 d-flex justify-content-between align-items-center cursor-pointer ${index < fourthBatch.length-1 ? "border-settings" : ""} ${selected === item ? "bg-grey-blue white" : "bg-white grey-blue"}`}>
							{
								item === "support"
								? <span className="body">{t("settings.support")}</span>
								: item === "warranty"
								? <span className="body">{t("settings.warranty")}</span>
								: <span className="body">{t("settings.user_manuals")}</span>
							}
							<img className={`size_15 ${selected === item ? "white-icon": "primary-icon"}`} src={icons.chevron_right} alt={""} />
						</div>
					))}
				</div>
				<div className="d-flex flex-column settings-radius primary mt-3">
					{fifthBatch.map((item, index) =>(
						<div 
							key={index} 
							onClick={() => setShowLogout(true)}
							className={`p-3 d-flex justify-content-center align-items-center cursor-pointer bg-red text-white bold ${index < fifthBatch.length-1 ? "border-settings" : ""}`}>
							<span className={`body white-white`}>{t(`settings.${item}`)}</span>
							{/* <img className={`size_15 ${selected === item ? "white-icon": "primary-icon"}`} src={icons.chevron_right} alt={""} /> */}
						</div>
					))}
				</div>
			</div>
		</div>
		</>
		)
	}

	return(
		<>
		{settingsListContent()}
		<div className={`${!selected ? "d-none": ""} settings-right-section scrollable-y`}>
			{renderSettingsType(selected)}
		</div>
		

        <LogoutModal show={showLogout} onClose={() => setShowLogout(!showLogout)} />
		</>
	)
}

export default SettingsNew;
